import './SearchDialog.css'

import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import 'dialog-closedby-polyfill'
import { MagnifyingGlass } from '#design-system/icons/magnifying-glass'

interface SearchDialogProps {
  isOpen: boolean
  onClose: () => void
}

export const SearchDialog = ({ isOpen, onClose }: SearchDialogProps) => {
  const { t } = useTranslation()
  const dialogRef = useRef<HTMLDialogElement>(null)

  // React -> browser dialog: keep the native open state aligned with the controlled `isOpen`
  // prop by calling showModal()/close() when that prop changes.
  useEffect(() => {
    const node = dialogRef.current
    if (!node) {
      return
    }
    if (isOpen && !node.open) {
      node.showModal()
    } else if (!isOpen && node.open) {
      node.close()
    }
  }, [isOpen])

  // Browser dialog -> React: when native close paths fire (Escape/backdrop via `closedby="any"`),
  // invoke onClose so parent state stays in sync with the actual dialog state.
  useEffect(() => {
    const node = dialogRef.current
    if (!node) {
      return
    }
    node.addEventListener('close', onClose)
    return () => {
      node.removeEventListener('close', onClose)
    }
  }, [onClose])

  return (
    <dialog
      ref={dialogRef}
      aria-label={t('shell.nav.search_panel')}
      className="search-dialog"
      closedby="any"
    >
      <p className="placeholder">
        <MagnifyingGlass />
        {t('shell.nav.search_coming_soon')}
      </p>
    </dialog>
  )
}
